<template>
  <div>
    <form @submit.prevent="saveMenuItem">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <span class="pl-2">
            {{ input ? "Edit" : "Add" }} Merchant Config
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="2" class="pr-0">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error': errors.first('outletCode') }">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first("outletCode") }}</small>
              </b-col>
              <b-col md="2" class="pr-0">
                <label>Auto Print Stages</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error': errors.first('autoPrintStages') }">
                <div
                  class="dropdown-trigger form-control"
                  name="autoPrintStages"
                  type="text"
                  @click="toggleDropDown(true)"
                >
                  {{ autoPrintStages.join(',') }}
                </div>
                <div v-show="showDropDown" class="dropdown-list">
                  <b-form-checkbox-group v-model="autoPrintStages" :options="stages" />
                  <b-button size="sm" @click="toggleDropDown(false)">Close</b-button>
                </div>

                <small>{{ errors.first("autoPrintStages") }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="2" class="pr-0">
                <label>Printing Address</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('printingAddress') }">
                <b-textarea
                  v-model="printingAddress"
                  v-validate="'required'"
                  type="text"
                  name="printingAddress"
                />
                <small>{{ errors.first("printingAddress") }}</small>
              </b-col>
              <b-col md="2" class="pr-0">
                <label>Printing Type</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('printingType') }">
                <b-form-select v-model="obj.printingType" name="printingType" :options="['Bluetooth','Network']" />
                <small>{{ errors.first("printingType") }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Status</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="status" />
              </b-col>
              <!--
              <b-col md="3">
                <label>Is Auto Print Receipt</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="isAutoPrintReceipt" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Is Auto Print Menu</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="autoPrintMenu" />
              </b-col>
              -->
              <b-col md="3">
                <label>Staff Pin Valid</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="staffPinValid" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Vendor</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('messageVendor') }">
                <b-form-select v-model="messageVendor" name="messageVendor" :options="vendorOptions" />
                <small>{{ errors.first("messageVendor") }}</small>
              </b-col>
            </b-row>
            <b-row v-if="messageVendor === vendorOptions[1].value" class="mt-2">
              <b-col md="3">
                <label>Language</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('messageLanguage') }">
                <b-form-select v-model="messageLanguage" name="messageLanguage" :options="languageOptions" />
                <small>{{ errors.first("messageLanguage") }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Message Group</label>
              </b-col>
              <b-col md="4" :class="{ 'form-error pl-0': errors.first('messageGroup') }">
                <b-form-select
                  v-model="messageGroup"
                  name="messageGroup"
                  :options="messageGroupOptions"
                  :disabled="!!messageGroupLoadError"
                />
                <small>{{ errors.first("messageGroup") }}</small>
                <small v-if="messageGroupLoadError" class="text-danger d-block">
                  {{ messageGroupLoadError }}
                  <a href="#" @click.prevent="loadMessageGroups">Retry</a>
                </small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>EDC Mapping</label>
              </b-col>
              <b-col md="9" :class="{ 'form-error': errors.first('edcMapping') }">
                <b-btn variant="success" @click="addEdcMapping">
                  Add
                </b-btn>
              </b-col>
            </b-row>
            <b-row v-for="(item, index) in edcMappingList" :key="index" class="mt-2">
              <b-col md="5">
                <b-row>
                  <b-col md="2" class="edc-mapping">
                    <span>TID</span>
                  </b-col>
                  <b-col md="10">
                    <b-form-input
                      v-model="item.tid"
                      v-validate="'required'"
                      type="text"
                      :name="`TID${item.tid}`"
                    />
                    <small>{{ errors.first(`TID${item.tid}`) }}</small>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="5">
                <b-row>
                  <b-col md="2" class="edc-mapping">
                    <span>MID</span>
                  </b-col>
                  <b-col md="10">
                    <b-form-input
                      v-model="item.mid"
                      v-validate="'required'"
                      type="text"
                      :name="`MID${item.mid}`"
                    />
                    <small>{{ errors.first(`MID${item.mid}`) }}</small>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="2">
                <b-btn variant="danger" @click="deleteEdcMappingItem(index)">
                  Delete
                </b-btn>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="2">
                <label>Special Days</label>
              </b-col>
              <b-col class="mt-1">
                <b-textarea v-model="obj.specialDays" type="text" />
                <span style="color: #979595; line-height: 2;">E.g. 2023-12-31,2024-09-22</span>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="3">
                <label>Open Birthdate</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.birthdateDisplay" :value="1" :unchecked-value="0" />
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="3">
                <label>User Note</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="userNoteActive" :value="1" :unchecked-value="0" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>User Level</label>
              </b-col>
              <b-col md="4">
                <b-form-select v-model="userNoteLevel" :options="noteLevelOptions" />
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col md="3">
                <label>Open Tagging</label>
              </b-col>
              <b-col md="3" class="mt-1">
                <b-form-checkbox v-model="obj.showTagging" :value="1" :unchecked-value="0" />
              </b-col>
            </b-row>
            <template v-if="obj.showTagging">
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Gender Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="obj.genderTaggingActive" :value="1" :unchecked-value="0" />
                </b-col>
              </b-row>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Age Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="obj.ageRangeTaggingActive" :value="1" :unchecked-value="0" />
                </b-col>
              </b-row>
              <template v-if="obj.ageRangeTaggingActive">
                <b-row class="mt-1 ml-4">
                  <b-col md="3">
                    <label>Age Range</label>
                  </b-col>
                  <b-col md="9">
                    <b-btn variant="success" @click="addAgeRange">
                      Add
                    </b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-3">
                  <b-col md="3" />
                  <b-col md="6" class="mt-1">
                    <b-row v-for="(item, index) in ageRange" :key="index" class="mt-2">
                      <b-col>
                        <b-form-input
                          v-model="ageRange[index]"
                          type="text"
                          :name="item"
                        />
                      </b-col>
                      <b-col>
                        <b-btn variant="danger" @click="deleteAgeRangeItem(index)">
                          Delete
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Ethnicity Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="ethnicityTagging.active" />
                </b-col>
              </b-row>
              <template v-if="ethnicityTagging.active">
                <b-row class="mt-1 ml-4">
                  <b-col md="3">
                    <label>Ethnicity</label>
                  </b-col>
                  <b-col md="6">
                    <b-btn variant="success" @click="addTaggingOption('ethnicityTagging')">
                      Add
                    </b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-3">
                  <b-col md="3" />
                  <b-col md="6" class="mt-1">
                    <b-row v-for="(item, index) in ethnicityTagging.options" :key="index" class="mt-2">
                      <b-col>
                        <b-form-input
                          v-model="ethnicityTagging.options[index]"
                          type="text"
                          :name="item"
                        />
                      </b-col>
                      <b-col>
                        <b-btn variant="danger" @click="deleteTaggingOption('ethnicityTagging', index)">
                          Delete
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Occasions Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="occasionsTagging.active" />
                </b-col>
              </b-row>
              <template v-if="occasionsTagging.active">
                <b-row class="mt-1 ml-4">
                  <b-col md="3">
                    <label>Occasions</label>
                  </b-col>
                  <b-col md="3">
                    <b-form-checkbox v-model="occasionsTagging.isMultiple" class="form-checkbox">
                      Multiple Choice
                    </b-form-checkbox>
                  </b-col>
                  <b-col md="6">
                    <b-btn variant="success" @click="addTaggingOption('occasionsTagging')">
                      Add
                    </b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-3">
                  <b-col md="3" />
                  <b-col md="6" class="mt-1">
                    <b-row v-for="(item, index) in occasionsTagging.options" :key="index" class="mt-2">
                      <b-col>
                        <b-form-input
                          v-model="occasionsTagging.options[index]"
                          type="text"
                          :name="item"
                        />
                      </b-col>
                      <b-col>
                        <b-btn variant="danger" @click="deleteTaggingOption('occasionsTagging', index)">
                          Delete
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Treatment Preferences Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="treatmentTagging.active" />
                </b-col>
              </b-row>
              <template v-if="treatmentTagging.active">
                <b-row class="mt-1 ml-4">
                  <b-col md="3">
                    <label>Treatment Preference</label>
                  </b-col>
                  <b-col md="3">
                    <b-form-checkbox v-model="treatmentTagging.isMultiple" class="form-checkbox">
                      Multiple Choice
                    </b-form-checkbox>
                  </b-col>
                  <b-col md="6">
                    <b-btn variant="success" @click="addTaggingOption('treatmentTagging')">
                      Add
                    </b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-3">
                  <b-col md="3" />
                  <b-col md="6" class="mt-1">
                    <b-row v-for="(item, index) in treatmentTagging.options" :key="index" class="mt-2">
                      <b-col>
                        <b-form-input
                          v-model="treatmentTagging.options[index]"
                          type="text"
                          :name="item"
                        />
                      </b-col>
                      <b-col>
                        <b-btn variant="danger" @click="deleteTaggingOption('treatmentTagging', index)">
                          Delete
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Food Preferences Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="foodPreferencesTagging.active" />
                </b-col>
              </b-row>
              <template v-if="foodPreferencesTagging.active">
                <b-row class="mt-1 ml-4">
                  <b-col md="3">
                    <label>Food Preferences</label>
                  </b-col>
                  <b-col md="6">
                    <b-btn variant="success" @click="addTaggingOption('foodPreferencesTagging')">
                      Add
                    </b-btn>
                  </b-col>
                </b-row>
                <b-row class="mt-1 mb-3">
                  <b-col md="3" />
                  <b-col md="6" class="mt-1">
                    <b-row v-for="(item, index) in foodPreferencesTagging.options" :key="index" class="mt-2">
                      <b-col>
                        <b-form-input
                          v-model="foodPreferencesTagging.options[index]"
                          type="text"
                          :name="item"
                        />
                      </b-col>
                      <b-col>
                        <b-btn variant="danger" @click="deleteTaggingOption('foodPreferencesTagging', index)">
                          Delete
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
              <b-row class="mt-1 ml-1">
                <b-col md="3">
                  <label>Member Status Tagging</label>
                </b-col>
                <b-col md="3" class="mt-1">
                  <b-form-checkbox v-model="memberStatusTaggingActive" :value="1" :unchecked-value="0" />
                </b-col>
              </b-row>
            </template>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn v-if="submitLoading" type="submit" disabled variant="success">
            Uploading
          </b-btn>
          <b-btn
            v-else-if="messageGroupLoadError"
            disabled
            variant="success"
            title="Message group options failed to load"
          >
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn
            v-else
            type="submit"
            variant="success"
          >
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash'
import { getResponseToMTH } from '@/utils/helpers'
import constants from '@/utils/constants'

// Keeps a value the backend no longer returns (deactivated or deleted) visible
// in the dropdown, so editing an unrelated field cannot silently clear it.
const withCurrentValue = (options, current) => {
  if (!current || options.some(o => o.value === current)) {
    return options;
  }
  return [...options, { value: current, text: `${current} (inactive)` }];
};

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: { printingType: 'Bluetooth' },
      submitLoading: false,
      constants,
      status: false,
      isAutoPrintReceipt: false,
      autoPrintMenu: false,
      stages: [
        'SUBMITTED',
        'PAYMENT_SUCCESS',
        'PREPARING',
        'READY_PICKUP',
        'COMPLETED'
      ],
      autoPrintStages: [],
      showDropDown: false,
      edcMappingList: [],
      printingAddress: '',
      ageRange: constants.DEFAULT_AGE_RANGE,
      ethnicityTagging: {
        active: false,
        options: constants.DEFAULT_ETHNICITY_OPTIONS,
      },
      occasionsTagging: {
        active: false,
        isMultiple: false,
        options: constants.DEFAULT_OCCASIONS_OPTIONS,
      },
      // Treatment Preferences
      treatmentTagging: {
        active: false,
        isMultiple: false,
        options: [],
      },
      foodPreferencesTagging: {
        active: false,
        options: constants.DEFAULT_FOOD_PREFERENCES_OPTIONS,
      },
      memberStatusTaggingActive: 0,
      userNoteActive: 0,
      userNoteLevel: 'brand',
      noteLevelOptions: [
        { value: 'brand', text: 'Brand' },
        { value: 'outlet', text: 'Outlet' }
      ],
      vendorOptions: constants.VendorOptions,
      languageOptions: constants.LanguageOptions,
      messageVendor: constants.DefaultVendor,
      messageLanguage: constants.DefaultLanguage,
      messageGroup: '',
      firstRender: true,
      isLoadingEditData: false,
    }
  },
  computed: {
    // Options for the selected vendor, with the current value kept visible even
    // if the backend no longer offers it.
    messageGroupOptions() {
      const options = this.$store.getters.GetMessageGroupOptionsByVendor(
        this.messageVendor
      )
      return withCurrentValue(options, this.messageGroup)
    },
    messageGroupLoadError() {
      return this.$store.getters.LoadErrorMessageGroup
    },
  },
  watch: {
    obj: function(newVal) {
      if (newVal.id) {
        this.isLoadingEditData = true
        const edcMappings = []
        const formatData = JSON.parse(newVal.printingAddress)
        this.printingAddress = `${Object.keys(formatData)[0]} ${
          Object.values(formatData)[0]
        }`
        this.status = newVal.status === 1
        this.isAutoPrintReceipt = newVal.isAutoPrintReceipt === 1
        this.autoPrintMenu = newVal.autoPrintMenu === 1
        this.staffPinValid = newVal.staffPinValid === 1
        this.autoPrintStages = newVal.autoPrintStages
          .split(',')
          .filter(item => item !== '')
        this.messageVendor = newVal.messageVendor || constants.DefaultVendor
        this.messageLanguage = newVal.messageLanguage || constants.DefaultLanguage
        this.messageGroup = newVal.messageGroup || this.defaultMessageGroupValue(this.messageVendor)
        this.memberStatusTaggingActive = newVal.memberStatusTaggingActive || 0
        this.userNoteActive = newVal.userNoteActive ? 1 : 0
        this.userNoteLevel = newVal.userNoteLevel || 'brand'
        try {
          for (let key in JSON.parse(newVal.edcMapping)) {
            edcMappings.push({
              tid: key,
              mid: JSON.parse(newVal.edcMapping)[key]
            })
          }
        } catch (error) {
          throw error
        }
        this.edcMappingList = edcMappings
        if (newVal.ageRange && newVal.ageRange.split(',').length) {
          this.ageRange = newVal.ageRange.split(',')
        }
        if (newVal.ethnicityTagging && newVal.ethnicityTagging !== '{}') {
          const ethnicityTaggingObj = JSON.parse(newVal.ethnicityTagging);
          this.ethnicityTagging = {
            active: ethnicityTaggingObj.active,
            options: ethnicityTaggingObj.options
          }
        }
        if (newVal.occasionsTagging && newVal.occasionsTagging !== '{}') {
          const occasionsTaggingObj = JSON.parse(newVal.occasionsTagging);
          this.occasionsTagging = {
            active: occasionsTaggingObj.active,
            isMultiple: occasionsTaggingObj.isMultiple,
            options: occasionsTaggingObj.options
          }
        }
        if (newVal.treatmentTagging && newVal.treatmentTagging !== '{}') {
          const treatmentTaggingObj = JSON.parse(newVal.treatmentTagging);
          this.treatmentTagging = {
            active: treatmentTaggingObj.active,
            isMultiple: treatmentTaggingObj.isMultiple,
            options: treatmentTaggingObj.options
          }
        }
        if (newVal.foodPreferencesTagging && newVal.foodPreferencesTagging !== '{}') {
          const foodPreferencesTaggingObj = JSON.parse(newVal.foodPreferencesTagging);
          this.foodPreferencesTagging = {
            active: foodPreferencesTaggingObj.active,
            options: foodPreferencesTaggingObj.options
          }
        }
        this.$nextTick(() => {
          this.isLoadingEditData = false
        })
      }
    },
    messageVendor: function(newVal) {
      if (!this.firstRender && !this.isLoadingEditData) {
        this.messageGroup = this.defaultMessageGroupValue(newVal)
      }
    },
  },
  mounted: function() {
    this.firstRender = false;
    this.loadMessageGroups();
  },
  methods: {
    // First option offered for a vendor; '' when the list has not loaded or the
    // vendor has no entries.
    defaultMessageGroupValue(vendor) {
      const options = this.$store.getters.GetMessageGroupOptionsByVendor(vendor)
      return options.length ? options[0].value : ''
    },

    loadMessageGroups() {
      return this.$store
        .dispatch('LoadMessageGroup')
        .then(() => {
          // An add form starts empty and can only pick its default once the
          // options have arrived.
          if (!this.messageGroup && !this.isLoadingEditData) {
            this.messageGroup = this.defaultMessageGroupValue(this.messageVendor)
          }
        })
        .catch(() => {
          this.$swal(
            constants.SOMETHING_WROING,
            this.messageGroupLoadError,
            constants.STATUS_ERROR
          )
        })
    },

    saveMenuItem() {
      this.$validator.validate().then(valid => {
        try {
          if (valid) {
            let edcMappingsObj = {}
            this.submitLoading = true
            this.obj.status = this.status ? 1 : 0
            this.obj.isAutoPrintReceipt = this.isAutoPrintReceipt ? 1 : 0
            this.obj.autoPrintMenu = this.autoPrintMenu ? 1 : 0
            this.obj.autoPrintStages = this.autoPrintStages.join(',')
            this.obj.staffPinValid = this.staffPinValid ? 1 : 0
            if (this.printingAddress.split(' ')[1]) {
              this.obj.printingAddress = JSON.stringify({
                [this.printingAddress.split(
                  ' '
                )[0]]: this.printingAddress.split(' ')[1]
              })
            } else {
              this.obj.printingAddress = JSON.stringify({
                [this.printingAddress.split(' ')[0]]: ''
              })
            }
            this.edcMappingList.forEach(item => {
              edcMappingsObj = { ...edcMappingsObj, [item.tid]: item.mid }
            })
            this.obj.edcMapping = JSON.stringify(edcMappingsObj)
            this.obj.ageRange = _.compact(this.ageRange)
            this.obj.ethnicityTagging = JSON.stringify({
              active: this.ethnicityTagging.active,
              options: _.compact(this.ethnicityTagging.options)
            })
            this.obj.occasionsTagging = JSON.stringify({
              active: this.occasionsTagging.active,
              isMultiple: this.occasionsTagging.isMultiple,
              options: _.compact(this.occasionsTagging.options)
            })
            this.obj.treatmentTagging = JSON.stringify({
              active: this.treatmentTagging.active,
              isMultiple: this.treatmentTagging.isMultiple,
              options: _.compact(this.treatmentTagging.options)
            })
            this.obj.foodPreferencesTagging = JSON.stringify({
              active: this.foodPreferencesTagging.active,
              options: _.compact(this.foodPreferencesTagging.options)
            })
            this.obj.memberStatusTaggingActive = this.memberStatusTaggingActive
            this.obj.userNoteActive = this.userNoteActive
            this.obj.userNoteLevel = this.userNoteLevel
            this.obj.messageVendor = this.messageVendor
            this.obj.messageLanguage = this.messageVendor === this.vendorOptions[1].value ? this.messageLanguage : constants.DefaultLanguage
            this.obj.messageGroup = this.messageGroup
            if (this.input === null) {
              this.$store
                .dispatch('CreateMerchantConfig', this.obj)
                .then(response => {
                  this.submitLoading = false
                  let res = getResponseToMTH(
                    response,
                    this.$swal,
                    'Record is created'
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                  if (response.invalidMessage !== 'SUCCESS') {
                    this.$swal(
                      constants.SOMETHING_WROING,
                      response.invalidMessage,
                      constants.STATUS_ERROR
                    )
                  }
                })
                .catch(error => {
                  this.submitLoading = false
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error.response.data.message,
                    constants.STATUS_ERROR
                  )
                })
            } else {
              this.$store
                .dispatch('UpdateMerchantConfig', this.obj)
                .then(response => {
                  this.submitLoading = false
                  let res = getResponseToMTH(
                    response,
                    this.$swal,
                    constants.RECORD_IS_UPDATED
                  )
                  if (res) {
                    this.$emit('discard-modal', true)
                    this.reset()
                  }
                })
                .catch(error => {
                  this.submitLoading = false
                  this.$swal(
                    constants.SOMETHING_WROING,
                    error.response.data.message,
                    constants.STATUS_ERROR
                  )
                })
            }
          }
        } catch {
          this.submitLoading = false
        }
      })
    },

    discardModal() {
      this.reset()
      this.$emit('discard-modal')
    },

    reset() {
      if (this.input == null) {
        this.obj = { printingType: 'Bluetooth' }
      } else {
        this.obj = this.input
      }
    },

    toggleDropDown(status) {
      this.showDropDown = status
    },

    addEdcMapping() {
      const newEdcMapping = [
        {
          tid: '',
          mid: ''
        }
      ]
      this.edcMappingList = [...this.edcMappingList, ...newEdcMapping]
    },
    deleteEdcMappingItem(index) {
      const mappingList = _.cloneDeep(this.edcMappingList)
      mappingList.splice(index, 1)
      this.edcMappingList = mappingList
    },

    addAgeRange() {
      const newAgeRange = ['']
      this.ageRange = [...this.ageRange, ...newAgeRange]
    },
    deleteAgeRangeItem(index) {
      const dataList = _.cloneDeep(this.ageRange)
      dataList.splice(index, 1)
      this.ageRange = dataList
    },

    addTaggingOption(taggingKey) {
      const newTaggingOption = ['']
      if (this[taggingKey] && this[taggingKey].options) {
        this[taggingKey].options = [...this[taggingKey].options, ...newTaggingOption]
      }
    },
    deleteTaggingOption(taggingKey, index) {
      const dataList = _.cloneDeep(this[taggingKey].options)
      dataList.splice(index, 1)
      this[taggingKey].options = dataList
    },
  }
}
</script>
<style lang="scss">
.dropdown-trigger {
  overflow: scroll;
}
.dropdown-list {
  width: 180px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
}
.edc-mapping {
  display: flex;
  align-items: center;
}
.custom-control-label {
  span {
    margin-top: -13px;
  }
}
</style>
